
import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//comopnents:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getTipoMovRedemList, modifyTipoMovRedem, removeTipoMovRedem, addTipoMovRedem, updateTipoMovRedemListDB } from '../../actions/tipo_mov_redem_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresTipoMovRedem extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getTipoMovRedemList();

    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkTipoMovRedem = (tipoMovRedem) => {
        if (this.props.tipoMovRedemList.find(c => (c.descr === tipoMovRedem.descr) && (c.id !== tipoMovRedem.id))) {
            this.messageDialog(`Ya existe un tipo de movimiento con descripción ${tipoMovRedem.descr}`);
            return false;
        } else if (!tipoMovRedem.descr.trim()) {
            this.messageDialog('Por favor, introduzca una Descripción');
            return false;
        } else if (!tipoMovRedem.descrWeb.trim()) {
            this.messageDialog('Por favor, introduzca una Descripción Web');
            return false;
        }

        else return true;
    };

    addNewTipoMovRedem = (tipoMovRedem) => {
        this.props.setSaveState(true);
        this.props.addTipoMovRedem(tipoMovRedem);
    };

    newTipoMovRedem = () => {
        this.props.openDialog('EditTipoMovRedem', {
            tipoMovRedem: {},
            okHandler: this.addNewTipoMovRedem,
            checkTipoMovRedem: this.checkTipoMovRedem,
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {

        for (let i = fromRow; i <= toRow; i++) {
            let updatedRow = update(this.props.tipoMovRedemList[i], { $merge: updated });
            if (this.checkTipoMovRedem(updatedRow)) {
                if (typeof updated.b_signo !== 'undefined') {
                    updatedRow.signo = (updated.b_signo ? 1 : -1);
                }
                this.props.setSaveState(true);
                this.props.modifyTipoMovRedem(updatedRow);
            }
        }
    };

    handleDeleteRow = (tipoMovRedem) => {
        this.props.setSaveState(true);
        this.props.removeTipoMovRedem(tipoMovRedem);
    };

    render() {

        const { classes } = this.props;

        this.props.tipoMovRedemList.forEach(p => p.b_signo = (p.signo > 0))

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div style={{ marginBottom: 20 }}>
                        <NeuriteGrid
                            id="m_r_t_m_r"
                            columns={[
                                { key: 'descr', name: 'Descripción', editable: true, dragable: false, width: 255 },
                                { key: 'descrWeb', name: 'Descripción Web', editable: true, dragable: false, width: 255 },
                                { key: 'b_signo', name: 'Carga?', tooltip: 'Indica si es una carga de puntos', type: 'bool', editable: true, dragable: false, width: 55 },
                                { key: 'activo', name: 'Activo', type: 'bool', editable: true, dragable: false, width: 55 },
                                { key: 'bClienteVisible', name: 'Web ?', type: 'bool', editable: true, dragable: false, width: 55 },
                            ]}
                            rows={this.props.tipoMovRedemList}
                            height={500}
                            buttonEdit={false}
                            buttonDelete={false} // antes true pero no debe poder modif. por el usuario
                            buttonNew={false} // idem ant.
                            // onNewRowClick={this.newTipoMovRedem}
                            onRowsUpdated={this.handleGridRowsUpdated}
                            // onDeleteClick={this.handleDeleteRow}
                        />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.tipoMovRedemList.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateTipoMovRedemListDB(this.props.tipoMovRedemList)
                }}>Guardar</Button>
            </div >
        );

    };

};

MaeAuxiliaresTipoMovRedem.propTypes = {
    //state
    tipoMovRedemList: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getTipoMovRedemList: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyTipoMovRedem: PropTypes.func.isRequired,
    removeTipoMovRedem: PropTypes.func.isRequired,
    addTipoMovRedem: PropTypes.func.isRequired,
    updateTipoMovRedemListDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        tipoMovRedemList: state.tipoMovRedem.tipoMovRedemList,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getTipoMovRedemList,
        openDialog,
        hideDialog,
        modifyTipoMovRedem,
        removeTipoMovRedem,
        addTipoMovRedem,
        updateTipoMovRedemListDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresTipoMovRedem));